import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import WorldMap from './pages/WorldMap/WorldMap';
import './styles/main.scss';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<WorldMap />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
